import BarcodeSVG from "@design-system/ui-icons/vanilla/Barcode"
import { createIcon } from "../createIcon"

export const BarcodeIcon = createIcon(BarcodeSVG)
